import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router';
import { useScroll, useMotionValueEvent } from 'framer-motion';
import { useBreakpoint } from './hooks';
import { IAlbum } from './utilities';

type HeaderState = 'hidden' | 'default';

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const Mode = ({
  useDarkTheme,
  setDarkTheme,
}: {
  useDarkTheme: boolean;
  setDarkTheme: (value: boolean) => void;
}) => {
  const [showDark, setShowDark] = useState(useDarkTheme);
  useEffect(() => {
    setShowDark(useDarkTheme);
  }, [useDarkTheme]);

  return (
    <div className="Header__mode">
      <a className={`Header--btn ${showDark ? 'selected' : ''}`} onClick={() => setDarkTheme(true)}>
        dark
      </a>
      <a
        className={`Header--btn ${!showDark ? 'selected' : ''}`}
        onClick={() => setDarkTheme(false)}
      >
        light
      </a>
    </div>
  );
};

const Name = ({ closeMenu, headerState }: { closeMenu: () => void; headerState: HeaderState }) => {
  const location = useLocation();
  const key = location.pathname;
  const atHome = key === '/';
  const allPath = location.pathname.split('/');

  const breakpoint = useBreakpoint();

  if (allPath.length > 2 && breakpoint === 'mobile') {
    return (
      <div className={`Header__name ${headerState === 'hidden' ? '' : ''}`}>
        <Link
          className={`Header--link ${atHome ? 'selected' : ''}`}
          to={`/${allPath[1]}`}
          onClick={closeMenu}
        >
          back
        </Link>
      </div>
    );
  }

  return (
    <div className={`Header__name ${headerState === 'hidden' ? '' : ''}`}>
      <Link className={`Header--link ${atHome ? 'selected' : ''}`} to="/" onClick={closeMenu}>
        dante tobar
      </Link>
    </div>
  );
};

const Menu = ({ toggleMenu, showMenu }: { toggleMenu: () => void; showMenu: boolean }) => {
  const key = location.pathname.split('/')[1];
  return (
    <>
      {/* <Link className={`Header--link Header__current ${showMenu && 'hidden'}`} to={`/${key}`}> */}
      {/*   {!showMenu && key} */}
      {/* </Link> */}
      <div />
      <button className={`Header__menu ${showMenu ? 'selected' : ''}`} onClick={toggleMenu}>
        menu
      </button>
    </>
  );
};

const Navigation = () => {
  const location = useLocation();
  const [hoverPage, setHoverPage] = useState(null);

  useEffect(() => {
    const key = location.pathname.split('/')[1];

    switch (key) {
      case '':
        setHoverPage('home');
        break;
      case 'photo':
        setHoverPage('home');
        break;
      case 'about':
        setHoverPage('about');
        break;
      case 'archive':
        setHoverPage('archive');
        break;
      case 'work':
        setHoverPage('work');
        break;
      default:
        setHoverPage('home');
        break;
    }
  }, [location]);

  return (
    <div className="Header__nav">
      <Link to="/archive" className={`Header--link ${hoverPage === 'archive' ? 'selected' : ''}`}>
        archive
      </Link>
      <Link to="/work" className={`Header--link ${hoverPage === 'work' ? 'selected' : ''}`}>
        work
      </Link>
      <Link to="/about" className={`Header--link ${hoverPage === 'about' ? 'selected' : ''}`}>
        about
      </Link>
    </div>
  );
};

const Header = ({
  useDarkTheme,
  setDarkTheme,
  toggleMenu,
  closeMenu,
  showMenu,
  albums,
}: {
  useDarkTheme: boolean;
  setDarkTheme: (value: boolean) => void;
  toggleMenu: () => void;
  closeMenu: () => void;
  showMenu: boolean;
  albums: IAlbum[];
}) => {
  const location = useLocation();
  const [headerState, setHeaderState] = useState<HeaderState>('hidden');
  const { scrollY } = useScroll();

  useEffect(() => {
    if (location.pathname === '/' || location.pathname === '/photo') {
      if (scrollY.get() < 300) {
        setHeaderState('hidden');
      } else {
        scrollToTop();
      }
    } else {
      setHeaderState('default');
    }
  }, [location, albums]);

  useMotionValueEvent(scrollY, 'change', latest => {
    if (location.pathname !== '/') {
      setHeaderState('default');
    } else {
      if (latest < 300) {
        setHeaderState('hidden');
      } else if (latest > 300) {
        setHeaderState('default');
      }
    }
  });

  return (
    <>
      <span className={`Header__background ${headerState === 'hidden' ? 'hidden' : ''}`} />
      <div className={`Header ${showMenu ? 'Header--open' : ''}`}>
        <Name closeMenu={closeMenu} headerState={headerState} />
        <div className={'Header__bio'}>
          <p>photographer - engineer</p>
          <p>based in new york</p>
        </div>
        <Navigation />
        <Mode useDarkTheme={useDarkTheme} setDarkTheme={setDarkTheme} />
        <Menu toggleMenu={toggleMenu} showMenu={showMenu} />
      </div>
    </>
  );
};

export default Header;
